import {useEffect} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import FleetMaintenancesService from "../../../../../services/reports/fleet-maintenances-service.js";

export default function ReportContent({ data, filters, tableColumns }) {
    const getObservation = (element) => {
        const dtStart = filters.dtStart ? ReportUtils.formatDateTime(filters.dtStart) : "";
        const dtEnd = filters.dtEnd ? ReportUtils.formatDateTime(filters.dtEnd) : "";

        if (element.modality === "Avaria") return <a href={FleetMaintenancesService.damage(element.vehicle_id, dtStart, dtEnd)} target="_blank" className="print:text-black! report-link">{element.description ?? "Sem Observação"}</a>;
        if (element.modality === "Manutenção") return <a href={FleetMaintenancesService.maintenances(element.id)} target="_blank" className="print:text-black! report-link">{element.description ?? "Sem Observação"}</a>;

        return element.description ?? "";
    };

    const columns = [
        {id: "vehicle_info", label: "Veículo", className: "w-[20%]", renderCell: element => element.vehicle_info ?? ""},
        {id: "date", label: "Data/hora", className: "w-[13.33%]", renderCell: element => element.date ?? ""},
        {id: "modality", label: "Modalidade", className: "w-[13.33%]", renderCell: element => element.modality ?? ""},
        {id: "user", label: "Agente", className: "w-[13.33%]", renderCell: element => element.user ?? ""},
        {id: "description", label: "Observações", className: "w-[40%]", renderCell: getObservation}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "Avarias, manutenções e vistorias", "fleet-maintenances-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="fleet-maintenances-data" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Avarias, manutenções e vistorias">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {data?.map((element, index) => {
                        return (
                            <tr key={element.id ?? index}>
                                {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    )
}